exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mb-10[data-v-e5f35972]{margin-bottom:10rem}", ""]);

// exports
